import type { ReactElement } from 'react';
import useAddresses from 'hooks/useAddresses';
import Checkbox from 'components/shared/Checkbox';
import { patch } from 'utils/network';
import FetchState from 'models/FetchState';
import { ApiRoute } from 'config';

type Props = { className?: string; };

function NotificationsDisclaimerCard({ className }: Props): ReactElement {
  const { addresses, reload: reloadAddresses, fetchState } = useAddresses();
  const primaryAddress = addresses && addresses[0];
  const isAddressLoading = fetchState === FetchState.IN_PROGRESS;

  const hasSmsSubscription = !isAddressLoading && primaryAddress;

  const toggleSmsSubscriptionStatus = async (smsSubscription: string) => {
    const status = primaryAddress[smsSubscription] === 'sms_opted_in' ? 'sms_opted_out' : 'sms_opted_in';
    const payload = {
      shipping_address: { [smsSubscription]: status },
    };
    await patch(`${ApiRoute.SHIPPING_ADDRESSES}/${primaryAddress.id}`, payload);

    reloadAddresses();
  };

  if (!hasSmsSubscription) {
    // @ts-expect-error TODO: fix null safety
    return null;
  }

  return (
    <div className={`col-12 c-profile__address-payments-wrapper ${className}`}>
      <div className="c-card c-profile__card">
        <div className="c-card__content">
          <h2 className="c-profile__card-heading">
            Notifications
          </h2>

          <div className="c-profile__notification-checkboxs">
            <div className="c-profile__notification-checkbox-card">
              <Checkbox
                id="add-account-alerts"
                label="Order & Account Notifications"
                checked={
                  primaryAddress.sms_notification_status === 'sms_opted_in'
                }
                onChange={() => toggleSmsSubscriptionStatus('sms_notification_status')}
              />
              <p className="c-profile__notification-checkbox-info">
                Get order updates, tracking details, and other important account alerts.
              </p>
            </div>
            <div className="c-profile__notification-checkbox-card">
              <Checkbox
                id="add-offers-alerts"
                label="Offers & Updates"
                checked={
                  primaryAddress.sms_offers_status === 'sms_opted_in'
                }
                onChange={() => toggleSmsSubscriptionStatus('sms_offers_status')}
              />
              <p className="c-profile__notification-checkbox-info">
                Receive exclusive deals, personalized menu recommendations, and more!
              </p>
            </div>
          </div>
          <p className="c-profile__notification-disclaimer">
            By opting-in, you agree to receive recurring, automated promotional and
            personalized marketing text messages and/or important account updates from Purple Carrot
            at the phone number used when signing up. Message frequency will vary—don&apos;t worry
            we promise not to spam you! Message and data rates will apply. Reply HELP for help or
            STOP to cancel. Consent is not a condition of purchase. View&nbsp;
            <a
              target="_blank"
              rel="noreferrer"
              href="/terms"
            >
              Terms & Conditions
            </a>
            &nbsp;and&nbsp;
            <a
              target="_blank"
              rel="noreferrer"
              href="/privacy"
            >
              Privacy Policy
            </a>
            .
          </p>
        </div>
      </div>
    </div>
  );
}

export default NotificationsDisclaimerCard;
